// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PERITADOR_ACT_GET_CAR_GALERY_BEGGIN,
  PERITADOR_ACT_GET_CAR_GALERY_SUCCESS,
  PERITADOR_ACT_GET_CAR_GALERY_FAILURE
} from './constants'
import { BFFAgent } from '../../../common/BFFAgent'

const DATA_TYPE = 'MAESTRO'

export function actGetCarGalery(id) {
  return dispatch => {
    dispatch({
      type: PERITADOR_ACT_GET_CAR_GALERY_BEGGIN
    })

    const promise = new Promise((resolve, reject) => {
      BFFAgent.Datamasters.getAuto(id)
        .then(auto => {
          BFFAgent.Files.getFileOnlyImages({ id }, DATA_TYPE)
            .then(imgs => {
              dispatch({
                type: PERITADOR_ACT_GET_CAR_GALERY_SUCCESS,
                data: {
                  auto,
                  images: imgs || []
                }
              })
              resolve(auto)
            })
            .catch(errorImgs => {
              dispatch({
                type: PERITADOR_ACT_GET_CAR_GALERY_FAILURE,
                data: errorImgs
              })
              reject(errorImgs)
            })
        })
        .catch(errorAuto => {
          dispatch({
            type: PERITADOR_ACT_GET_CAR_GALERY_FAILURE,
            data: errorAuto
          })
          reject(errorAuto)
        })
    })

    return promise
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_ACT_GET_CAR_GALERY_BEGGIN:
      return {
        ...state,
        actGetCarGaleryPending: true
      }
    case PERITADOR_ACT_GET_CAR_GALERY_SUCCESS:
      return {
        ...state,
        actGetCarGaleryPending: false,
        carGalery: action.data
      }
    case PERITADOR_ACT_GET_CAR_GALERY_FAILURE:
      return {
        ...state,
        actGetCarGaleryPending: false,
        actGetCarGaleryError: action.data
      }
    default:
      return state
  }
}
